export enum UserStatisticsActionName {
  'writer' = 'f_writer_stats',
  'factchecker' = 'f_factchecker_stats',
  'compiler' = 'f_compiler_stats',
}
